export default {
    'diagram3a3-2': {
        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
        'diagram-description': {
            '1': 'Predictive analysis is starting to be used widely in business',
            '2': 'When things break down, they generally don’t do so all at once, but gradually over time',
            '3': 'Specific patterns typically crop up before something breaks',
            '4': 'Telltale signs are the whirring of a motor, excessive heat from an engine, and the like',
        },
        'elements': {
            'one': 'Predictive analysis looks for patterns rather than causes in solving problems',
            'two': 'When things break down, they do so gradually over time',
            'three': 'Armed with sensor data, correlational analysis and similar methods we can identify the specific patterns that typically crop up before something breaks',
            'four': 'From then on, need only look for that pattern to know when something is amiss',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a3/diagram2/i18n/en.js